export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// SSO token refresh endpoint, relative to the user's auth environment's SSO API
// (authEnvs.js).
export const SSO_REFRESH_TOKEN = "/v1.2/auth/refresh";

// Content endpoint: authenticated API that serves MDX/MD content from blob storage.
// Unused for now (MDX stays bundled). TODO(Part 2).
export const CONTENT = "/api/v1/content";
